export default {
    computed: {
        family () {
            return this.$store.getters['family/getFamily'];
        },
        meeting () {
            return (
                this.family.sheets &&
        this.family.sheets.find((el) => {
            return el.sheet_type === 'meeting';
        })
            );
        },
        meetingData () {
            return this.meeting && this.meeting.sheet_data;
        },
        isMedicsPackageEmpty () {
            return (
                this.family &&
        this.family.medics_package == null &&
        this.$store.getters['specialistPackage/getDraft'] == null
            );
        },
        doctorsPack () {
            return this.meetingData && this.meetingData.doctorsPack;
        }
    }
};
